// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__23QKB","messages":"Chat_messages__16HEX","dateDivider":"Chat_dateDivider__2P6Q2"};